const HOMEPAGE_URL =
  'https://s3.amazonaws.com/sos.texastribune.org/top-news/2018-primary.json';
const RESULTS_URL =
  'https://s3.amazonaws.com/sos-test.texastribune.org/results/2018-primary-flat.json';
const INDIVIDUAL_RESULT_URL = id =>
  `https://s3.amazonaws.com/sos-test.texastribune.org/results/contests/${id}.json`;

export { HOMEPAGE_URL, INDIVIDUAL_RESULT_URL, RESULTS_URL };



// WEBPACK FOOTER //
// ./endpoints.js